/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { ModelUtils } from '../util/ModelUtils';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { MarshallCompat } from '../../compat/MarshallCompat';
import { Info } from '../../core/models/common/Info';
import { Contact } from '../../core/models/common/Contact';
import { Node } from '../../core/models/Node';

/**
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class ChangeContactCommand extends AbstractCommand {
    public _newName : string;

    public _newEmail : string;

    public _newUrl : string;

    public _oldContact : any;

    public _nullInfo : boolean;

    public constructor(name? : any, email? : any, url? : any) {
        if(((typeof name === 'string') || name === null) && ((typeof email === 'string') || email === null) && ((typeof url === 'string') || url === null)) {
            let __args = arguments;
            super();
            if(this._newName===undefined) this._newName = null;
            if(this._newEmail===undefined) this._newEmail = null;
            if(this._newUrl===undefined) this._newUrl = null;
            if(this._oldContact===undefined) this._oldContact = null;
            if(this._nullInfo===undefined) this._nullInfo = false;
            if(this._newName===undefined) this._newName = null;
            if(this._newEmail===undefined) this._newEmail = null;
            if(this._newUrl===undefined) this._newUrl = null;
            if(this._oldContact===undefined) this._oldContact = null;
            if(this._nullInfo===undefined) this._nullInfo = false;
            (() => {
                this._newName = name;
                this._newEmail = email;
                this._newUrl = url;
            })();
        } else if(name === undefined && email === undefined && url === undefined) {
            let __args = arguments;
            super();
            if(this._newName===undefined) this._newName = null;
            if(this._newEmail===undefined) this._newEmail = null;
            if(this._newUrl===undefined) this._newUrl = null;
            if(this._oldContact===undefined) this._oldContact = null;
            if(this._nullInfo===undefined) this._nullInfo = false;
            if(this._newName===undefined) this._newName = null;
            if(this._newEmail===undefined) this._newEmail = null;
            if(this._newUrl===undefined) this._newUrl = null;
            if(this._oldContact===undefined) this._oldContact = null;
            if(this._nullInfo===undefined) this._nullInfo = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[ChangeContactCommand] Executing.");
        this._oldContact = null;
        this._nullInfo = false;
        if(this.isNullOrUndefined(document.info)) {
            this._nullInfo = true;
            document.info = document.createInfo();
            this._oldContact = null;
        } else {
            this._oldContact = null;
            if(ModelUtils.isDefined(document.info.contact)) {
                this._oldContact = Library.writeNode(document.info.contact);
            }
        }
        document.info.contact = document.info.createContact();
        document.info.contact.name = this._newName;
        document.info.contact.url = this._newUrl;
        document.info.contact.email = this._newEmail;
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[ChangeContactCommand] Reverting.");
        if(this._nullInfo) {
            document.info = null;
        } else if(ModelUtils.isDefined(this._oldContact)) {
            document.info.contact = document.info.createContact();
            Library.readNode(this._oldContact, document.info.contact);
        } else {
            document.info.contact = null;
        }
    }
}
ChangeContactCommand["__class"] = "io.apicurio.datamodels.cmd.commands.ChangeContactCommand";
ChangeContactCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




